export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/hatchback-icon.8095e40c.svg","height":12,"width":26,"blurWidth":0,"blurHeight":0};